import { TextField, Box, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { loadTrainingLevel, loadUsers, loadTrainingStatus, loadEmpTrainingStatus, loadEmployeeLevel } from '../../../redux/actions/lookups.action'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

function TrainingFilter(props) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(6);
  const [level, setLevel] = useState("");
  const [employee, setEmployee] = useState(0);
  const [period, setPeriod] = useState("");
  const [status, setStatus] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [empLevel, setEmpLevel] = useState("");
  const [levelOption, setLevelOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [statusOption, setStatusOption] = useState([]);
  const [employeeLevelOption, setEmployeeLevelOption] = useState([]);
  const [empStatusOption, setEmpStatusOption] = useState([]);
  const [period_list, setPeriod_list] = useState([])
  const sort_list = [
    { value: "StartDate", label: "Start Date" },
    { value: "EndDate", label: "End Date" },
    { value: "UserCount", label: "Attendees" },
    { value: "Title", label: "Title" },
    { value: "StatusId", label: "Training status" }
  ]

  let LUTrainingLevel = useSelector(state => state.loadTrainingLevel_Reducer.trainingLevelList)
  let LUusersList = useSelector((state) => state.loadUsers_Reducer.usersList);
  let LUTrainingStatus = useSelector((state) => state.loadTrainingStatus_Reducer.trainingStatus);
  let LUEmpTrainingStatus = useSelector((state) => state.loadEmpTrainingStatus_Reducer.empTrainingStatus);
  let LUEmployeeLevel = useSelector(state => state.loadEmployeeLevel_Reducer.employeeLevel);


  useEffect(() => {
    dispatch(loadTrainingLevel())
    dispatch(loadUsers())
    dispatch(loadTrainingStatus())
    dispatch(loadEmpTrainingStatus())
    dispatch(loadEmployeeLevel());
    sort_list.map((value) => {
      if (value.value === "StatusId") {
        var sort = [];
        sort.push(value);
        setOrderBy(sort)
      }
    })

    const arr = [];
    const valarr = [];
    const d = new Date();
    let year = d.getFullYear() + 1;
    let value = year;
    [0, 1, 2].map((val) => {
      let value1 = value - 1;
      arr.push(value1);
      console.log(arr);
      value = value1;
    })
    arr.map((val) => {
      var h1 = { value: `${val}-H1`, label: `${val} - H1` }
      valarr.push(h1);
      var h2 = { value: `${val}-H2`, label: `${val} - H2` }
      valarr.push(h2);
      console.log(valarr)

    })
    setPeriod_list(valarr)


  }, [])

  useEffect(() => {
    if (LUTrainingLevel.length > 0) {
      setLevelOption(LUTrainingLevel)
    }
  }, [LUTrainingLevel])

  useEffect(() => {
    if (LUusersList.length > 0) {
      setUserOption(LUusersList)
    }
  }, [LUusersList])

  useEffect(() => {
    if (LUTrainingStatus.length > 0) {
      setStatusOption(LUTrainingStatus)
    }
  }, [LUTrainingStatus])

  useEffect(() => {
    if (LUEmpTrainingStatus.length > 0) {
      setEmpStatusOption(LUEmpTrainingStatus)
    }
  }, [LUEmpTrainingStatus])

  useEffect(() => {
    if(LUEmployeeLevel.length > 0) {
      setEmployeeLevelOption(LUEmployeeLevel)
    }
  },[LUEmployeeLevel])

  const handleFilter = () => {
    var levelId = "";
    var empId = 0;
    var dateVal = "";
    var yearVal = "";
    var statuId = 0;
    var empLevelId = "";
    if (level !== undefined && level !== "") {
      levelId = level.value;
    }
    if(empLevel !== undefined && empLevel !== "") {
      empLevelId = empLevel.value;
    }
    if (employee !== undefined && employee !== 0 && employee !== "") {
      empId = employee.value;
    }
    if (period !== undefined && period !== "") {
      var value = period.value;
      dateVal = value.split("-")[0];
      yearVal = value.split("-")[1];
    }
    if (status !== undefined && status !== 0 && status !== "") {
      statuId = parseInt(status.value)
    }

    
    var req;
    if (props.from === "mytrainings") {
      req = {
        "page": pageNo,
        "title": title,
        "resultsPerPage": resultsPerPage,
        "statusId": statuId,
      }
    }
    else {
      req = {
        "page": pageNo,
        "title": title,
        "resultsPerPage": resultsPerPage,
        "year": dateVal,
        "trainingLevelId": levelId,
        "employeeLevelId":empLevelId,
        "dateFilter": yearVal,
        "statusId": statuId,
        "employeeId": empId
      }
    }
      props.onFilter(req);
  }
  const handleTitle = (e) => {    
    setTitle(e.target.value);
    props.searchTitle(e.target.value);    
  }
  const handleClear = () => {
    if (props.from === "mytrainings") {
      var req = {
        "page": pageNo,
        "title": "",
        "resultsPerPage": resultsPerPage,
        "statusId": 0,
      }
      setTitle("");
      setStatus("");
      props.searchTitle("");
      props.onFilter(req);
      props.searchStatus(0);
    }
    else {
      var req = {
        "page": pageNo,
        "title": "",
        "resultsPerPage": resultsPerPage,
        "year": "",
        "trainingLevelId": "",
        "employeeLevelId": "",
        "dateFilter": "",
        "statusId": 0,
        "employeeId": 0
      }
      setTitle("");
      setLevel("");
      setEmployee("");
      setPeriod("");
      setStatus("");
      setEmpLevel("");
      props.searchEmployee(0)
      props.serachLevel("")
      props.searchTitle("");
      props.searchPeriod("", "");
      props.onFilter(req);
      props.searchStatus(0);
      props.searchEmpLevel("");
    }

  }
  const handleLevel = (selected) => {
    setLevel(selected)
    props.serachLevel(selected.value)
  }
  const handleEmployee = (selected) => {
    setEmployee(selected)
    props.searchEmployee(selected.value)
  }
  const handlePeriod = (selected) => {
    setPeriod(selected)
    var value = selected.value;
    var dateValue = value.split("-")[0];
    var yearValue = value.split("-")[1];
    props.searchPeriod(dateValue, yearValue);
  }
  const handleStatus = (selected) => {
    setStatus(selected)
    props.searchStatus(parseInt(selected.value))
  }
  const handleEmpLevel = (selected) => {
    setEmpLevel(selected)
    props.searchEmpLevel(selected.value)
  }
  // const handleSort = (selected) => {
  //   setOrderBy(selected)
  //   props.sortBy(selected.value)
  // }
  return (
    <div className="argus-filter-employee" style={{ marginRight: "0", paddingBottom: "20px" }}>
      <h3 className="filters">Filters</h3>
      <ValidatorForm style={{ backgroundColor: "#fff" }} onSubmit={() => handleFilter()}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextValidator
              id="standard-basic"
              label="Search by Training Title"
              variant="outlined"
              value={title}             
              onChange={handleTitle}
              fullWidth
            />
          </Grid>
          {props.from === "mytrainings" ?
            <Grid item xs={12}>
              <Select placeholder={<div>Select Status</div>}
                options={empStatusOption}
                value={status}
                onChange={handleStatus}
              />
            </Grid> : ""
          }
          {props.from !== "mytrainings" ?
            <><Grid item xs={12}>
              <Select
                placeholder={<div>Search by training level</div>}
                options={levelOption}
                value={level}
                onChange={handleLevel}
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                placeholder={<div>Search experience/level</div>}
                options={employeeLevelOption}
                value={empLevel}
                onChange={handleEmpLevel}
              />
            </Grid>
              <Grid item xs={12}>
                {/* <span style={{visibility: "hidden"}}>a</span> */}
                <Select placeholder={<div>Select Status</div>}
                  options={statusOption}
                  value={status}
                  onChange={handleStatus}
                />
              </Grid>
            </> : ""}

          {props.from !== "mytrainings" ? <Grid item xs={12}>
            {/* <span style={{visibility: "hidden"}}>a</span> */}
            <Select
              placeholder={<div>Search by Employee</div>}
              options={userOption}
              value={employee}
              onChange={handleEmployee}
            />
          </Grid> : ""}
          {props.from !== "mytrainings" ? <Grid item xs={12}>
            {/* <span style={{visibility: "hidden"}}>a</span> */}
            <Select placeholder={<div>Select period</div>}
              options={period_list}
              value={period}
              onChange={handlePeriod}
            />
          </Grid> : ""}
          {/* {props.from !== "mytrainings" ?<Grid item xs={3}>
            <span>Sort by</span>
            <Select placeholder={<div>Sort by</div>}
            options ={sort_list}
            value = {orderBy}
            onChange={handleSort}
            />
          </Grid>:""} */}
          <Grid item xs={12} sx={{ textAlign: "center", marginTop: "10px" }}>
            <Button className="theme-btn cancel-btn" sx={{ float: "none", marginRight: "10px" }} variant="contained"
              onClick={() => handleClear()}>
              Clear
            </Button>
            <Button className="theme-btn" sx={{ float: "none", marginRight: "10px" }} variant="contained" type="submit">
              Search
            </Button>            
          </Grid>

        </Grid>
      </ValidatorForm>
    </div>
  );
}
export default TrainingFilter;
